export default {"src":"/_next/static/media/WhereAreFacilitiesIconRed.f25b9297.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};